import { Controller } from '@hotwired/stimulus';

// URL のハッシュが指す collapse を開く。Bootstrap の collapse は閉じた状態で
// 描画されるため、外部からのリンクで来ても本文が見えない。
export default class extends Controller {
  connect() {
    this.openFromHash();
    this.hashChangeHandler = this.openFromHash.bind(this);
    window.addEventListener('hashchange', this.hashChangeHandler);
  }

  disconnect() {
    window.removeEventListener('hashchange', this.hashChangeHandler);
  }

  openFromHash() {
    const hash = window.location.hash;
    if (!hash || hash.length < 2) return;

    let target;
    try {
      target = this.element.querySelector(hash);
    } catch (e) {
      return;
    }
    if (!target) return;

    // FAQ の id は、カードの手前にある非表示の見出しに付いている。
    const container = this.collapseContainer(target);
    if (!container) return;

    const panel = container.classList.contains('collapse') ? container : container.querySelector('.collapse');
    if (!panel.classList.contains('show')) {
      panel.classList.add('show');

      const toggle = this.element.querySelector(`[data-bs-target="#${panel.id}"]`);
      if (toggle) {
        toggle.classList.remove('collapsed');
        toggle.setAttribute('aria-expanded', 'true');
      }
    }

    container.scrollIntoView();
  }

  collapseContainer(target) {
    const hasPanel = (el) => el && (el.classList.contains('collapse') || el.querySelector('.collapse'));
    if (hasPanel(target)) return target;

    const next = target.nextElementSibling;
    return hasPanel(next) ? next : null;
  }
}
